import * as React from 'react';
import * as styles from './ai-button.module.scss';
import AiStars from '../icons/ai-stars';
import classNames from '../../utilities/class-names';

export const AiButton = ({ onClick, className, showIcon = true, href, children, contentClassName }) => {
  const ButtonComponent = href ? 'a' : 'button';
  const buttonProps = href ? { href, target: '_blank', rel: 'noreferrer' } : { onClick, type: 'button' };

  return (
    <ButtonComponent {...buttonProps} className={classNames(styles.aiButton, className)}>
       {showIcon && <AiStars className={styles.aiChatIcon} />}
       <div className={contentClassName}>{children}</div>
    </ButtonComponent>
  );
}

export default AiButton;